import React, { useEffect, useRef } from 'react';
import { SmilePlus, Stethoscope, ShieldCheck, Zap, ScanSearch } from 'lucide-react';

export function ServiceFeePackage() {
  const sectionRef = useRef(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          const items = document.querySelectorAll('.service-item');
          items.forEach((item, index) => {
            setTimeout(() => {
              item.classList.add('animate-in');
            }, 150 * index);
          });
        }
      },
      { threshold: 0.2 }
    );
    
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const items = [
    { icon: <SmilePlus size={28} />, title: "Personalized Treatment Planning" },
    { icon: <Stethoscope size={28} />, title: "One-on-One Time with Dentist" },
    { icon: <ShieldCheck size={28} />, title: "High-Quality Materials" },
    { icon: <Zap size={28} />, title: "Comfort-First Approach" },
    { icon: <ScanSearch size={28} />, title: "Modern Technology" },
  ];

  return (
    <section ref={sectionRef} className="py-16 px-6 text-center relative overflow-hidden">
      <div className="relative z-10">
        <h2 className="text-3xl font-bold bg-gradient-to-r from-teal-600 to-green-600 bg-clip-text text-transparent mb-4 inline-block">
          What's Included in Your Care
        </h2>
        
        <div className="w-20 h-1 bg-gradient-to-r from-teal-400 to-green-400 mx-auto mb-10 rounded-full"></div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mx-auto">
          {items.map((item, i) => (
            <div 
              key={i} 
              className="service-item flex flex-col items-center text-center space-y-4 p-6 rounded-xl bg-white shadow-md hover:shadow-lg transition-all duration-300 opacity-0 translate-y-8 transform"
              style={{ transitionProperty: 'opacity, transform', transitionDuration: '0.5s' }}
            >
              <div className="p-4 bg-gradient-to-br from-teal-100 to-green-100 text-teal-600 rounded-full shadow-inner">
                {item.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-800">{item.title}</h3>
              <div className="w-12 h-1 bg-gradient-to-r from-teal-300 to-green-300 mx-auto mt-2 rounded-full opacity-70"></div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Decorative curved elements */}
      <div className="absolute left-0 bottom-0 w-full h-16 overflow-hidden">
        <svg 
          viewBox="0 0 1200 120" 
          preserveAspectRatio="none" 
          className="absolute bottom-0 w-full h-full text-teal-50"
        >
          <path 
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V0C0,0,0,0,0,0C109,0,210.83,10.56,321.39,56.44Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </section>
  );
}

// Add this CSS to your global styles or component styles
const styles = `
  .service-item.animate-in {
    opacity: 1;
    transform: translateY(0);
  }
  
  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
    100% { transform: translateY(0px); }
  }
`;

export default function StyledServiceFeePackage() {
  return (
    <>
      <style>{styles}</style>
      <ServiceFeePackage />
    </>
  );
}